require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ./src/frontend-lib/~/core-js/library/modules/es7.symbol.async-iterator.js
// module id = 4TW7
// module chunks = 0